var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Approval Generate Invoice"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('open')],1),_c('vs-tab',{attrs:{"label":"Generated"}},[_c('generated')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }